<template>
  <div>

    <div v-if="showMessagesTranscription" @click.self="showMessagesTranscription = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

          <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

          <div style="clear: both;"></div>

          <div>
              <div v-if="loading_chat_conversation" :class="'w-full mb-3'">
                  <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
              </div>
              <div class="flex flex-row flex-wrap" v-else>
                  <div class="w-full">
                      <div id="chat-dialog-messages-list" style="max-height: 500px; overflow: auto;">
                          <div>
                              <b-list-group>
                                  <b-list-group-item

                                      v-for="(item, index) in messages" :key="index"

                                          class="d-flex align-items-center mb-4 pb-4"
                                          style="border: none; border-bottom: solid 1px #ededed;"
                                  >
                                      <b-avatar v-if="item.role == 'assistant' || !item.role"
                                              text="S1"
                                              class="mr-3 call-info-avatar"
                                      ></b-avatar>
                                      <b-avatar v-if="item.role == 'user'"
                                              text="S2"
                                              class="mr-3 call-info-avatar"
                                      ></b-avatar>
                                      <div>
                                          <span v-if="item.role == 'assistant'" class="mr-auto primary-color text-bold">AI Agent</span>
                                          <span v-else class="mr-auto warning-color text-bold">Customer</span>

                                          <div class="text-sm">{{ item.content }} </div>
                                      </div>
                                  </b-list-group-item>
                              </b-list-group>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          </div>

          <div class="bg-gray-100 rounded-b-lg px-6 py-4">

              <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showMessagesTranscription = false">
                  CLOSE
              </button>

              <div class="clearfix"></div>

          <div class="clearfix"></div>

          </div>

      </div>
  </div>

    <div class="w-full mb-4 reviews-wrapper" v-if="initial_loading" :class="((dashboard == 'true') ? 'dashboard-box-content-border' : '')">
      <v-skeleton-loader v-if="initial_loading"
        type="article, article, article"
      ></v-skeleton-loader>
    </div>

    <div class="w-full mb-4 reviews-wrapper" v-if="!initial_loading" :class="((dashboard == 'true') ? 'dashboard-box-content-border' : '')">

      <div v-if="dashboard != 'true' && social_posting != 'true'" class="workspace-review-summary">
        <div><span>Total reviews</span><strong>{{ allReviewsCount }}</strong></div>
        <div><span>Live reviews</span><strong>{{ liveCount }}</strong></div>
        <div><span>Responded</span><strong>{{ respondedCount }}</strong></div>
        <div><span>Awaiting response</span><strong>{{ notRespondedCount }}</strong></div>
      </div>
      <v-tabs
        v-model="showByResponded"
        v-show="dashboard != 'true' && social_posting != 'true'"
        >
        <v-tab :value="'all'">All ({{ allReviewsCount }})</v-tab>
        <v-tab :value="'live'">Live ({{ liveCount }})</v-tab>
        <v-tab :value="'responded'">Responded ({{ respondedCount }})</v-tab>
        <v-tab :value="'not-responded'">Not Responded ({{ notRespondedCount }})</v-tab>
        <v-tab :value="'deleted'">Deleted ({{ deletedCount }})</v-tab>
        <v-tab :value="'requests'" v-show="!isAccelerate()">Requests ({{ requestsCount }})</v-tab>
      </v-tabs>

      <div class="workspace-review-toolbar">
        <div class="float-right">

          <v-checkbox
            class="mb-2"
            v-model="all_selected"
            value="1"
            label="Select All"
            hide-details
             :ripple="false"
            v-if="showByResponded != 'responded' && dashboard != 'true' && social_posting != 'true' && reviews.length > 0 && showByResponded != 5"
          ></v-checkbox>
        </div>

        <div v-if="all_selected == 1 || selected_ids.length > 0 || all_selected_all_pages" class="float-right -mt-2 mr-3">
          <v-btn
            color="blue darken-1"
            class="mt-2 white--text"
            small
            dense
            @click="respondToReviewsSelected()"
          >
            <v-icon
              right
              dark
              class="mr-2"
            >
              mdi-message
            </v-icon>
            Responded
          </v-btn>
        </div>
      </div>

        <div style="clear: both;"></div>

        <v-alert
          color="blue-grey"
          dark
          text
          v-if="all_selected == 1"
        >
          <div v-if="!all_selected_all_pages">
            All {{ options.itemsPerPage }} reviews on this page are selected.
            <a href="javascript: void(0);" @click="all_selected_all_pages = true">Select all {{ totalFilteredReviews }} reviews</a>
          </div>

          <div v-else>
            All {{ totalFilteredReviews }} reviews are selected.
            <a href="javascript: void(0);" @click="resetSelection()">Clear selection</a>
          </div>
        </v-alert>

                  <div class="workspace-review-filters">
                    <div class="workspace-review-filter">
                    <v-text-field
                    v-model="searchLocal"
                    clearable
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    ></v-text-field>
                    </div>
                    <div class="workspace-review-filter">
                    <v-select :menu-props="{ bottom: true, offsetY: true, nudgeBottom: 6, contentClass: 'workspace-filter-menu' }"
                        v-model="filterImages"
                        clearable
                        outlined
                        dense
                        hide-details
                        :items="filters_yes_no_items"
                        label="Included Images"
                    ></v-select>
                    </div>

                    <div class="workspace-review-filter">
                    <v-select :menu-props="{ bottom: true, offsetY: true, nudgeBottom: 6, contentClass: 'workspace-filter-menu' }"
                        v-model="filterGoogleVerifiedJob"
                        clearable
                        outlined
                        dense
                        hide-details
                        :items="filters_yes_no_items"
                        label="Google Verified Job"
                    ></v-select>
                    </div>
                    <div class="workspace-review-filter">
                    <v-select :menu-props="{ bottom: true, offsetY: true, nudgeBottom: 6, contentClass: 'workspace-filter-menu' }"
                        v-model="filterGoogleLocalGuide"
                        clearable
                        outlined
                        dense
                        hide-details
                        :items="filters_yes_no_items"
                        label="Local Guide"
                    ></v-select>
                    </div>
                    <div class="workspace-review-filter">
                    <v-select :menu-props="{ bottom: true, offsetY: true, nudgeBottom: 6, contentClass: 'workspace-filter-menu' }"
                        v-model="filterPositive"
                        clearable
                        outlined
                        dense
                        hide-details
                        :items="filters_yes_no_items"
                        label="Positive"
                    ></v-select>
                    </div>
                    <div class="workspace-review-filter">
                    <v-select :menu-props="{ bottom: true, offsetY: true, nudgeBottom: 6, contentClass: 'workspace-filter-menu' }"
                        v-model="filterCritical"
                        clearable
                        outlined
                        dense
                        hide-details
                        :items="filters_yes_no_items"
                        label="Critical"
                    ></v-select>
                    </div>
                    <div class="workspace-review-filter">
                    <v-select :menu-props="{ bottom: true, offsetY: true, nudgeBottom: 6, contentClass: 'workspace-filter-menu' }"
                        v-model="filterService"
                        clearable
                        outlined
                        dense
                        hide-details
                        :items="filters_yes_no_items"
                        label="Service"
                    ></v-select>
                    </div>

                  </div>

        <div v-if="!loading_reviews && reviews.length == 0">
          <br /><br /><br />

          <div class="dashboard-box-iconsquare">
            <div class="dashboard-box-icon-background"></div>
            <div class="dashboard-box-icon">
              <i class="mdi mdi-star"></i>
            </div>
          </div>

          <div style="text-align: center; padding-bottom: 2px;">
            <div class="pt-2 pb-3">
              <strong>No Reviews</strong>
            </div>

            <div class="text-sm mb-4 text-gray-600">
              There are no reviews to be displayed.
            </div>
          </div>

          <br /><br /><br />
        </div>

        <v-data-table
            v-else
            :headers="headers"
            :items="reviews"
            :options.sync="options"
            :server-items-length="totalFilteredReviews"
            :items-per-page="((social_posting == 'true') ? 9999999 : 20)"
            class="elevation-1 workspace-review-feed"
            :loading="loading_reviews"
            :footer-props="{
            itemsPerPageOptions: ((social_posting == 'true') ? [9999999] : [1, 5, 10, 20, 30, 40, 50, 100]),
            showFirstLastPage: true
            }"
            :hide-default-footer="dashboard == 'true' || social_posting == 'true'"
            mobile-breakpoint="10"
        >

        <template v-slot:header>

          </template>
            <template v-slot:item.name="{ item }" style="color: #757B89;">
              <div class="reviewer">

                <div v-show="showByResponded != 5" style="float: left;" class="mr-3 mt-2" v-if="showByResponded != 'responded' && dashboard != 'true' && social_posting != 'true'">
                  <v-checkbox
                    v-model="selected_ids"
                    :value="item.id"
                    hide-details
                     :ripple="false"
                  ></v-checkbox>
                </div>

                <div style="float: left;">
                  <span class="ml-2">
                      <img class="profile-pic" referrerPolicy="no-referrer" :src="item.profile_picture" v-if="item.profile_picture" />
                      <v-avatar color="blue" size="50" v-if="!item.profile_picture" class="-ml-3"><v-icon small color="white">mdi-account</v-icon></v-avatar>
                  </span>
                </div>
                <div style="float: left;">
                  <h3 style="padding-top: 5px;">
                      {{ item.name }} <span v-if="item.is_request"> - {{ item.request_type }}</span>
                  </h3>
                  <span v-if="item.local_guide" class="text-xs"> · Local Guide</span>

                  <!-- <br />

                  <strong class="pl-2">{{ item.rating_value }}</strong> -->

                  <v-rating
                  v-show="!item.is_request"
                  :value="item.rating_value"
                  color="amber"
                  dense
                  half-increments
                  readonly
                  size="15"
                  ></v-rating>

                  <span class="review-date">{{ formatDate(item.date) }}</span>

                  <br clear="all" />

                  <div v-if="item.is_request" style="padding-left: 10px; clear: both; margin-top: 10px; float: left;">

                    <div style="font-size: 12px;">
                      <div>
                        &nbsp;&nbsp;|&nbsp;&nbsp; Lead ID: <strong>{{ item.request_lead_id || "N/A" }}</strong>
                      </div>

                      <div>
                        &nbsp;&nbsp;|&nbsp;&nbsp; Phone Number: <strong>{{ item.request_phone_number || "N/A" }}</strong>
                      </div>

                      <div>
                        &nbsp;&nbsp;|&nbsp;&nbsp; Email: <strong>{{ item.request_email || "N/A" }}</strong>
                      </div>
                    </div>

                    <div style="clear: both;"></div>

                    <div style="float: left;">
                      <v-chip
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"

                        v-if="item.request_approved"
                      >
                          Reviewed!
                      </v-chip>

                      <v-chip
                        small
                        color="red lighten-5"
                        text-color="red lighten-1"

                        v-else-if="item.request_negative_feedback"
                      >
                          Negative Feedback Received!
                      </v-chip>

                      <v-chip
                        small
                        color="blue lighten-5"
                        text-color="blue lighten-1"

                        v-else-if="item.request_link_clicked"
                      >
                          Link Clicked!
                      </v-chip>

                      <v-chip
                        small
                        color="blue lighten-5"
                        text-color="blue lighten-1"

                        v-else-if="item.link_sent"
                      >
                          Link Sent!
                      </v-chip>

                      <v-chip
                        small
                        color="orange lighten-5"
                        text-color="orange lighten-1"

                        v-else
                      >
                          Request Sent
                      </v-chip>
                    </div>
                  </div>
                  <div v-else style="padding-left: 10px; clear: both; margin-top: 10px; float: left;">
                    <v-chip
                      small
                      color="green lighten-5"
                      text-color="green lighten-1"

                      v-if="item.request_approved"
                    >
                        Received From Review Request!
                    </v-chip>
                  </div>
                </div>

                <br clear="all" />
            </div>
            </template>

            <template v-slot:item.listing_id="{ item }" style="color: #757B89;">
              <img class="reviews-source-logo -mr-2" :src="require('../assets/images/review-services/www.google.com.png')"></img>
            </template>

            <template v-slot:item.review_text="{ item }" style="color: #757B89;">
            <!-- <div class="review_text" v-if="dashboard != 'true'">
              {{ item.review_text }}
            </div> -->

            <div v-if="item.google_verified" class="text-xs" style="color: #FFB443; font-weight: bold;">
              Google Verified Job
            </div>

            <div class="review_text text-xs" :id="'item_text_' + item.id" style="color: #19233A;">
              <div v-if="item.review_text !== null">
                <div v-show="!item.show_all" v-html='((item.review_text.toString().length > 150) ? item.review_text.substring(0, 150) + "..." : item.review_text)' />
                <a v-if="!item.show_all && item.review_text.toString().length > 150" href="javascript: void(0);" @click="showFullText(item);">Read more</a>
              </div>

              <div v-if="showByResponded == 5 && item.request_recording_url">
                <audio controls>
                  <source :src="item.request_recording_url" type="audio/mpeg">
                  Your browser does not support the audio element.
                </audio>
              </div>

              <div v-if="showByResponded == 5 && item.request_type == 'sms'">
                <div class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 py-2 rounded cursor-pointer" @click="showMessagesTranscription = true; messages = getMessages(item)" style="margin-top: 4px; width: 200px;"><i class="fa fa-plus mr-2"> </i> SHOW MESSAGES</div>
              </div>
            </div>

            <div class="text-xs" style="color: #19233A;">
              <div v-if="item.service" class="pt-2">
                <strong>Service: </strong> {{ item.service }}
              </div>

              <div v-if="item.positive" class="pt-2">
                <strong>Positive: </strong> {{ item.positive }}
              </div>

              <div v-if="item.critical" class="pt-2">
                <strong>Critical: </strong> {{ item.critical }}
              </div>
            </div>

            <div v-if="item.photos">
              <div v-for="(item, index) in item.photos" :key="index" class="pt-2 pr-2" style="float: left;">
                <img :src="item" />
              </div>

              <div style="clear: both;"></div>
            </div>

            <div v-if="me.company_type == 'admin' || me.company_type == 'agency'" class="mt-3" style="font-size: 12px; color: #757B89;">
              <i class="mdi mdi-briefcase-outline" style="font-size: 16px;"></i>
              &nbsp;&nbsp;
              {{ item.user.company_name }}
              <span class="not-mobile">&nbsp;&nbsp;&nbsp;
              |
              &nbsp;&nbsp;
              </span>
              <br class="mobile-only" />
              <span>
                <span class="not-mobile">&nbsp;&nbsp;</span>
                <i class="mdi mdi-map-marker-outline" style="font-size: 16px;"></i>
                <span class="not-mobile">&nbsp;</span>&nbsp;
                {{ item.user.address }} {{ item.user.street_number }}<span v-if="(item.user.address || item.user.street_number)">, </span>{{ item.user.city }} <span v-if="!item.user.city">{{ item.user.country }}</span> &nbsp;<span v-if="item.user.company_type == 'business'" style="font-weight: bold;">(Main)</span>
              </span>
            </div>
            </template>

            <template v-slot:item.id="{ item }" style="color: #757B89;">
            <div style="float: right;" v-if="dashboard != 'true' && social_posting != 'true' && showByResponded != 5">
              <div class="float-right">
                <div v-if="item.responded" class="-mr-4">
                  <v-chip
                    class="ml-2 mr-2"
                    color="rgba(68, 70, 143, 0.1)"
                    text-color="#4EC5A1"
                  >
                    <i class="mdi mdi-check-circle mr-2"></i>
                    Responded
                  </v-chip>
                </div>

                <div v-else>
                  <div v-show="!responding[item.id]" class="border-1 border-purple text-primary text-xs text-bold px-4 py-2 rounded cursor-pointer -mr-3" @click="respondToReview(item)" style="margin-top: -5px; border-color: #4EC5A1; color: #4EC5A1 !important;"><i class="mdi mdi-forum-outline mr-2"> </i> Respond</div>

                  <div v-if="responding[item.id]" class="-mr-3">
                    <div class="text-gray-600 text-xs mb-3">Did you respond?</div>

                    <div class="border-1 border-purple text-primary text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-3" @click="notRespondedToReview(item)" style="margin-top: -5px; color: #4EC5A1 !important;"><i class="mdi mdi-close mr-2"> </i> No</div>

                    <div class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right" @click="respondedToReview(item)" style="margin-top: -5px;"><i class="mdi mdi-check mr-2"> </i> Yes</div>
                  </div>
                </div>
              </div>

            </div>
          </template>
        </v-data-table>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  import PanelNavigation from '@/components/PanelNavigation.vue'
  import moment from 'moment'

  export default {
    components: {
        PanelNavigation
    },
    props: ['dashboard', 'social_posting', 'sortBy', 'sortDesc', 'page', 'itemsPerPage', 'search', 'review_sites', 'date', 'selected_clients'],
    data () {
      return {
        options: {
          sortBy: "Newest First",
          sortDesc: true
        },
        headers: [
        { text: 'User & Rating', value: 'name', sortable: false },
        { text: 'Website', value: 'listing_id', sortable: false },
        { text: 'Feedback', value: 'review_text', width: 450, sortable: false },
        { text: 'Actions', value: 'id', sortable: false }
        ],
        read_more: [],
        percentage_complete: 0,
        filters_yes_no_items: [
          'Yes',
          'No'
        ],

        showByResponded: "all",

        searchLocal: "",
        filterImages: "",
        filterGoogleVerifiedJob: "",
        filterGoogleLocalGuide: "",
        filterPositive: "",
        filterCritical: "",
        filterService: "",
        filterDeleted: "",
        filterRequests: "",

        responding: {},

        all_selected: 0,
        all_selected_all_pages: false,
        selected_ids: [],

        actions_values: ['Mark As Responded'],

        showMessagesTranscription: false,
        messages: []
      }
    },
    computed: {
      ...mapState({
        reviews: state => state.reviews.reviews,
        loading_reviews: state => state.reviews.loading_reviews,
        initial_loading: state => state.reviews.initial_loading,
        totalFilteredReviews: state => state.reviews.totalFilteredReviews,
        totalReviews: state => state.reviews.totalReviews,
        notRespondedCount: state => state.reviews.notRespondedCount,
        respondedCount: state => state.reviews.respondedCount,
        deletedCount: state => state.reviews.deletedCount,
        requestsCount: state => state.reviews.requestsCount,
        allReviewsCount: state => state.reviews.allReviewsCount,
        liveCount: state => state.reviews.liveCount,
        me: state => state.me.me
      })
    },
    methods: {
      getHost() {
        return window.location.host;
      },

      isAccelerate() {
        // || this.getHost() == 'zany-space-palm-tree-q9vjg4xr39j97-8080.app.github.dev'
        // || this.getHost() == 'localhost:8080'
        return this.getHost() == 'lsa.accelerateyourmarketing.com';
      },

      getMessages(item) {
        if (item.request_transcription) {
          return JSON.parse(item.request_transcription).messages;
        }

        return [
          {
            "role": "assistant", 
            "content": "Hi there, my name is Mike and I'm a representative from " + this.me.company_name + ". I hope you're doing well today. I'd like to follow up on the services we provided for you and check if you're happy with the results so far. If so, would it be ok if I send you a review request?"
          }
        ];
      },

      getReviews: function(ignore_loading) {

        this.resetSelection();

        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        let sbr = 0;

        // console.log('this.showByResponded', this.showByResponded);

        if (this.showByResponded == 0)
          sbr = 'all';
        else if (this.showByResponded == 1)
          sbr = 'live';
        else if (this.showByResponded == 2)
          sbr = 'responded';
        else if (this.showByResponded == 3)
          sbr = 'not-responded';
        else if (this.showByResponded == 4)
          sbr = 'deleted';
        else if (this.showByResponded == 5)
          sbr = 'requests';

        let params = {
          dashboard: this.dashboard,
          social_posting: this.social_posting,
          social_posting_rating: ((this.$parent && this.$parent.$parent.me) ? this.$parent.$parent.me.social_posting_rating : 'undefined'),
          social_posting_review_sites: ((this.$parent && this.$parent.$parent.me) ? this.$parent.$parent.me.social_posting_review_sites : 'undefined'),
          sortBy: sortBy,
          sortDesc: sortDesc,
          page: page,
          itemsPerPage: itemsPerPage,
          search: this.searchLocal || "",
          filterImages: this.filterImages,
          filterGoogleVerifiedJob: this.filterGoogleVerifiedJob,
          filterGoogleLocalGuide: this.filterGoogleLocalGuide,
          filterPositive: this.filterPositive,
          filterCritical: this.filterCritical,
          filterService: this.filterService,
          filterDeleted: this.filterDeleted,
          filterRequests: this.filterRequests,
          showByResponded: sbr
        };

        if (typeof(this.review_sites) != "undefined")
          params.review_sites = this.review_sites;
        
        if (typeof(this.date) != "undefined")
          params.date = this.date;

        if (this.selected_clients)
          params.selected_clients = this.selected_clients;

        this.$store.dispatch('reviews/fetch', params);

        return;
      },
      getHostname: function(item) {
        return "google.com";
        // return new URL(item.url || item.listing.url).hostname.replace("www.", "").replace(".ca", ".com").replace("doctor.webmd", "webmd").replace("uk.trustpilot.com", "trustpilot.com").replace("ebay.co.uk", "ebay.com").replace("amazon.co.uk", "amazon.com").replace("glassdoor.co.uk", "glassdoor.com");
      },
      formatDate: function(date) {
        return moment(String(date)).format('MM/DD/YYYY')
      },
      displayExpansionTitle(item) {
        if (item.review_title)
          return item.review_title;

        if (item.review_text)
          return item.review_text.substring(0, 50) + '...';

        return 'No text';
      },
      async selectReviewItem(review_id) {
        // this.$router.push('social-share/' + review_id)

        await axios.post(process.env.VUE_APP_API_ENDPOINT + '/me/publish-social-post', {
          reviews_ids: [review_id]
        } , {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          },
        })

        this.$swal({
          title: "Queued",
          text: "Selected review was queued for posting!",
          showCancelButton: false,
        });

        this.getReviews();
      },
      respondToReview(item) {
        this.responding[item.id] = 1;

        if (!this.me.subscription.product_details.limits.generate_review_responses)
          window.open(item.url);

        this.getReviews()
      },
      openReview(item) {
        window.open(item.url);
      },
      async generateReviewResponses(item) {
        let self = this
        this.responding[item.id] = 2;
        this.getReviews()

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/reviews/get-responses`, {
          review_text: item.review_text,
          business_uuid: this.me.uuid
        }, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        })

        // setTimeout(function() {
          // console.log('response', response);
          self.responding[item.id] = response.data.responses;
          self.getReviews()
        // }, 2000);
      },
      async respondedToReview(item) {
        this.responding[item.id] = 0;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/reviews/responded`, {
          id: item.id
        }, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        })

        this.getReviews();
      },
      notRespondedToReview(item) {
        this.responding[item.id] = false;
        this.getReviews()
      },
      resetSelection() {
        this.all_selected = 0;
        this.selected_ids = [];
        this.all_selected_all_pages = false;
      },
      async respondToReviewsSelected() {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        let params = {
          selected_ids: this.selected_ids,
          all_selected_all_pages: this.all_selected_all_pages,
          dashboard: this.dashboard,
          social_posting: this.social_posting,
          social_posting_rating: ((this.$parent && this.$parent.$parent.me) ? this.$parent.$parent.me.social_posting_rating : 'undefined'),
          social_posting_review_sites: ((this.$parent && this.$parent.$parent.me) ? this.$parent.$parent.me.social_posting_review_sites : 'undefined'),
          sortBy: sortBy,
          sortDesc: sortDesc,
          page: page,
          itemsPerPage: itemsPerPage,
          search: this.searchLocal || "",
          filterImages: this.filterImages,
          filterGoogleVerifiedJob: this.filterGoogleVerifiedJob,
          filterGoogleLocalGuide: this.filterGoogleLocalGuide,
          filterPositive: this.filterPositive,
          filterCritical: this.filterCritical,
          filterService: this.filterService,
          showByResponded: this.showByResponded
        };
        
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/reviews/responded-bulk`, params, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        });

        this.getReviews()
      },

      async postReviewsSelected() {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        await axios.post(process.env.VUE_APP_API_ENDPOINT + '/me/publish-social-post', {
          reviews_ids: this.selected_ids,
          all_selected_all_pages: this.all_selected_all_pages,
          dashboard: this.dashboard,
          social_posting: this.social_posting,
          social_posting_rating: ((this.$parent && this.$parent.$parent.me) ? this.$parent.$parent.me.social_posting_rating : 'undefined'),
          social_posting_review_sites: ((this.$parent && this.$parent.$parent.me) ? this.$parent.$parent.me.social_posting_review_sites : 'undefined'),
          sortBy: sortBy,
          sortDesc: sortDesc,
          page: page,
          itemsPerPage: itemsPerPage,
          search: this.searchLocal || "",
          filterImages: this.filterImages,
          filterGoogleVerifiedJob: this.filterGoogleVerifiedJob,
          filterGoogleLocalGuide: this.filterGoogleLocalGuide,
          filterPositive: this.filterPositive,
          filterCritical: this.filterCritical,
          filterService: this.filterService,
          showByResponded: this.showByResponded
        } , {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          },
        })

        this.$swal({
          title: "Queued",
          text: "Selected reviews were queued for posting!",
          showCancelButton: false,
        });

        this.getReviews();
      },

      showFullText: function(item) {
          document.getElementById("item_text_" + item.id).innerHTML = item.review_text;
      },

      onCopy: function (e) {
        this.$swal({
          title: "Copied",
          text: "Response copied! Open the review link and paste your review.",
          showCancelButton: false,
          });
      },
      onError: function (e) {
        alert('Failed to copy the text to the clipboard')
        console.log(e);
      },
    },
    watch: {
      options: {
        handler () {
          this.getReviews()
        }
      },
      showByResponded: {
        handler () {
          this.getReviews();
        }
      },
      sortByLocal: {
        handler () {
          if (this.sortByLocal == 'Newest First') {
              this.options.sortBy = "date";
              this.options.sortDesc = true;
            }
            else if (this.sortByLocal == 'Oldest First') {
              this.options.sortBy = "date";
              this.options.sortDesc = false;
            }
            this.getReviews()
        }
      },
      searchLocal: {
        handler () {
          this.options.page = 1
          this.getReviews()
        }
      },
      filterImages: {
        handler () {
          this.options.page = 1
          this.getReviews()
        }
      },
      filterGoogleLocalGuide: {
        handler () {
          this.options.page = 1
          this.getReviews()
        }
      },
      filterGoogleVerifiedJob: {
        handler () {
          this.options.page = 1
          this.getReviews()
        }
      },
      filterPositive: {
        handler () {
          this.options.page = 1
          this.getReviews()
        }
      },
      filterCritical: {
        handler () {
          this.options.page = 1
          this.getReviews()
        }
      },
      filterService: {
        handler () {
          this.options.page = 1
          this.getReviews()
        }
      },
      all_selected: {
        handler() {
          if (this.all_selected == 1) {
            for (var i in this.reviews) {
              this.selected_ids.push(this.reviews[i].id);
            }
          }
          else {
            this.resetSelection();
          }
        }
      }
    },
    mounted () {
      var that = this
      this.$store.state.reviews.initial_loading = true
      setTimeout(function() {
        that.getReviews()
      }, 1000)
    },
  }
</script>

<style>
  tbody tr:hover {
    background-color: transparent !important;
  }

  .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th:last-child {
    text-align: right !important;
  }

  .reviews-wrapper table td {
    padding: 20px !important;
    padding-left: 20px !important;
  }

  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:last-child, .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:last-child {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
  }

	.v-avatar {
		cursor: pointer;
		border: solid 1px #CCCCCC !important;
	}

	.v-avatar.add-more {
    border: solid 1px #58c1d6 !important;
    color: #58c1d6 !important;
	}

  .searching .v-card__title {
    font-size: 15px;
  }

  .reviewer {
    padding-bottom: 10px;
  }

  table .v-rating {
    display: inline-block;
    margin-left: 20px;
    margin-top: -1px;
  }

  table h3 {
    display: inline-block;
    padding-left: 8px;
    padding-top: 3px;
    font-weight: bold;
  }

  .reviews-wrapper table .v-chip {
    float: right;
  }

  .manage-btn {
    float: right;
  }

  .searching .v-card__title {
    font-size: 15px;
  }

  .reviews-source-logo {
    /* float: right; */
    display: inline-block;
    width: 35px;
    /* height: 30px; */
    opacity: 0.8;
    margin-right: 0px;
    margin-top: 0px;
  }

  .profile-pic {
    border-radius: 50%;
    width: 45px;
    height: 45px;
    float: left;
  }

  /* .reviews-wrapper .v-data-table-header, .v-data-table__mobile-row__header {
    display: none;
  } */
  
  header .v-toolbar__content {
    width: auto;
  }

  .v-application .elevation-1 {
      border: 0px;
      webkit-box-shadow: none !important;
      box-shadow: none !important;
  }

  .reviewer {
    padding-bottom: 10px;
    position: relative;
  }

  .reviewer .v-rating {
    display: inline-block;
    margin-left: 10px;
    margin-top: -1px;
  }

  .reviewer h3 {
    display: inline-block;
    padding-left: 8px;
    padding-top: 3px;
    font-weight: bold;
    color: #19233A;
  }

  .review-date {
    font-size: 12px;
    color: #757B89;
    padding-left: 10px;
  }

  .review_text {
    padding-top: 10px;
    color: #757B89;
  }

  @media screen and (max-width: 767px) {
    .reviews-wrapper table td {
      padding: 5px !important;
      padding-top: 10px !important;
      padding-bottom: 10px !important;
    }
    
    .reviewer .v-rating {
      display: block;
      margin-left: 10px;
    }

    .manage-btn {
      position: absolute;
      top: 0px;
      right: 30px;
    }

    .reviews-source-logo {
      position: absolute;
      top: 0px;
      right: 0px;
    }

    .reviews-wrapper table .v-chip {
      float: none;
    }
  }
</style>